( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function PpdUploadCtrl ( $scope, Session, ppdFactory, fileService, UPLOAD_EVD_MSGS, $rootScope, logger ) {
		var self = this;

		self.fileFormats     = '';
		self.progress        = 0;
		self.file            = null;
		self.source          = [ ];
		self.loading         = false;
		self.pdName          = '';
		self.maxSize         = fileService.validation().maxSize;
		self.warningMsgs     = UPLOAD_EVD_MSGS;
		self.resourceId      = ppdFactory.getResourceId();
		self.viewDisabled    = ppdFactory.isViewDisabled();
		self.recommendedPDS  = ppdFactory.getRecommendedPDs();
		self.templatePreview = ppdFactory.isTemplatePreview();
		self.isDuplicate     = false;
		self.isUploading     = false;
		self.uploadRequest   = null;
		self.fileType        = ppdFactory.getFileType();

		var passThrough = {
			'$on'   : angular.noop,
			'abort' : angular.noop
		};

		function mapper ( item ) {
			item.name        = item.title;
			item.type        = 2;
			item.contentId   = item.id;
			item.ContentId   = item.id;
			item.contentName = item.name;
			item.ContentName = item.name;

			return item;
		}

		function filterFiles ( data ) {
			return data.resourceId === self.resourceId && data.fileType === self.fileType;
		}

		function updateProps ( data  ) {
			var attachedData = ppdFactory.getAttachedPDs();

			return  ppdFactory.attachProps( attachedData, data  );
		}

		function successGetUploadsCb ( data ) {
			var collection = JSON.parse( angular.toJson( data ) ).filter( filterFiles ).map( mapper );

			self.noSource = !collection.length;

			var newCollection = updateProps( collection );

			ppdFactory.setUploadedFiles( newCollection );

			self.source = ppdFactory.getUploadedFiles();
		}

		function getUploadedData () {
			self.loading = true;
			fileService.getAllByResourceId( self.resourceId )
			.then( successGetUploadsCb )
			.finally( function () {
				self.loading = false;
			} );
		}

		function getFileFormats () {
			fileService.initialize()
			.finally( function () {
				self.fileFormats = fileService.validation().fileFormats;
			} );
		}

		function setDefault ( isDup ) {
			self.isDuplicate = Boolean( isDup );
			self.progress    = 0;
		}

		function isDuplicate ( source, item ) {
			return source.some( function ( data ) {
				return data.id === item.id;
			} );
		}

		function addToSource ( item ) {
			var newItem = item;

			newItem.name       = item.title;
			newItem.type       = 2;
			newItem.isAttached = true;

			$scope.$parent.$emit( 'ppd:add', item );
			self.source.push( newItem );
		}

		function successCb ( res ) {
			if ( isDuplicate( self.source, res.data ) ) {
				setDefault( true );
				logger.notifyError( self.warningMsgs.pdDuplicate );
			} else {
				addToSource( res.data );
				setDefault();
				self.pdName        = '';
				self.pdDescription = '';
				logger.notifySuccess( self.warningMsgs.successUpload );
			}
		}

		function progressCb ( evt ) {
			self.progress = Math.min( 100, parseInt( 100.0 * evt.loaded / evt.total ) );

			$rootScope.$broadcast( 'file:uploading', self.progress );
		}

		function errorCb () {
			setDefault();
		}

		function finallyCb () {
			self.file = null;
			fileService.uploading.setFlag( false );

			$rootScope.$broadcast( 'file:uploading', self.progress );
		}

		function uploadFile ( file ) {
			var params = {
				'file'          : file,
				'private'       : false,
				'observationId' : self.resourceId,
				'type'          : self.fileType,
				'title'         : self.pdName,
				'description'   : self.pdDescription || undefined
			};

			fileService.uploading.setFlag( true );

			self.uploadRequest = fileService.upload( params );

			self.uploadRequest
			.then( successCb, errorCb, progressCb )
			.finally( finallyCb );
		}

		function onDestroy () {
			( $rootScope.uploadScope || passThrough ).$on( '$destroy', function () {
				setDefault();
				fileService.uploading.setFlag( false );
				( self.uploadRequest || passThrough ).abort();
			} );
		}

		function updateUploadedFiles ( pd ) {
			self.source = self.source.filter( function ( item ) {
				return pd.id !== item.id;
			} );

			// when deleting a file, make sure to remove that file pd if it's attached or assigned
			// removal of file pds should be applied to top, group and indicator level
			ppdFactory.updateMasterSource( pd );
		}

		function onUpdate () {
			$scope.$on( 'pd:update:uploaded-files', function ( event, pd ) {
				updateUploadedFiles( pd );
			} );
		}

		function updatePDName ( name ) {
			self.pdName = name;
		}

		function activate () {
			getFileFormats();
			getUploadedData();
			onDestroy();
			onUpdate();
		}

		self.isUploading  = fileService.uploading.getFlag();
		self.uploadFile   = uploadFile;
		self.progressCb   = progressCb;
		self.updatePDName = updatePDName;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'PpdUploadCtrl', PpdUploadCtrl );

	PpdUploadCtrl.$inject = [ '$scope', 'Session', 'ppdFactory', 'fileService', 'UPLOAD_EVD_MSGS', '$rootScope', 'logger' ];
} )( );
